<template>
  
    <el-container>
      <el-main>
        <h1>PDF annotator</h1>
        <h2>How to use pdf annotator?</h2>
        <h3>Step 1. setup pdfjs plugin path</h3>
        <ol>
            <li>Download pdfjs plugin,unzip it</li>
            <li>In ios , create a <code>ios</code>folder then put pdfjs folder in it</li>
            <li>In andriod , create a <code>andriod</code>folder then put pdfjs folder in it</li>
            <li>In pc , put pdfjs folder to <code>.obsidian</code>folder , in mac <i>command+shift+. </i> show the hidden folder</li>
            <li>Ctrl/cmd + p , click <i>set up pdfjs plugin path</i></li>
            <li>Restart obsidian and check path in obsidian markmind setting tab</li>
        </ol>
        <h4>Download pdf js plugin</h4>
        <div>
        <p><a href="https://github.com/MarkMindCkm/obsidian-markmind/releases/download/1.4.5/pc.pdfjs.zip">PC pdfjs plugin</a><br>
        <a href="https://github.com/MarkMindCkm/obsidian-markmind/releases/download/1.3.6/mobile.pdfjs.zip">andriod pdfjs plugin</a><br>
        <a href="https://github.com/MarkMindCkm/obsidian-markmind/releases/download/1.3.6/mobile.pdfjs.zip">ios pdfjs plugin</a></p>
        </div>
        <h4>Keep your pdfjs folder have these folder</h4>
        <div>
          <img src="../assets/markmind/pdfjs.gif" width="800" alt="">
        </div>
        <h5>Ctrl/Cmd + p</h5>

        <div>
          <img src="../assets/markmind/pdfjs1.gif" width="800" alt="">
        </div>

        <h3>Step 2. pdf annotator</h3>
        <p>Add yaml to markdown file</p>
               <pre>
        <code>
---

annotate-target: test/test.pdf
annotate-type: pdf

---
        </code>
       </pre>

       <p>Then you can find <i>Annotate pdf</i> command in more options</p>

         <p><code>annotate-target</code> support types:</p>

         <ul>
            <li>Pdf file in vault , like <code>test/test.pdf</code>,this is a relative path.</li>
            <li>Pdf file in other hard drives, like <code>file://C:/test/test.pdf</code>,this is a absolute path.</li>
            <li>Pdf file in web, like <code> https://mozilla.github.io/pdf.js/legacy/web/compressed.tracemonkey-pldi-09.pdf</code>,this is a link.</li>
         </ul>

         <div>
          <img src="../assets/markmind/pdfannotator.gif" width="800" alt="">
         </div>

        
        <h3>About screenshot folder of rect annotations </h3>
      <ul>
        <li>You can set up folder path ( A relative path , folder of your vault) to save screenshot folder of rect annotations in setting tab</li>
        <li>or you can add folder path in yaml</li>
      </ul>

       <div>
          <img src="../assets/markmind/pdfimg.gif" width="800" alt="">
         </div>

         

      <pre>

        <code>
---

annotate-target: test/test.pdf
annotate-type: pdf
annotate-image-target: assets/image

---
        </code>
      </pre>

      <h3>Use pdf annotator</h3>

       <div>
          <img src="../assets/markmind/pdf.gif" width="800" alt="">
         </div>

          <div>
          <img src="../assets/markmind/usepdfannotator.gif" width="800" alt="">
         </div>
           
         <h4>When you create annotate,the data will save by these way</h4>
         <ul>
              <li>it will create <i> annos </i> file in your folder as default, the annos file store annotations data,annos file is a <i>json</i> file in fact</li>
            
              <li>if you select (save pdf annotation type ) <i>markdown</i> in setting tab , it will create <i>${pdf name}-annotate.md</i> file in your folder. Each annotation has an associated quote block with a block reference. please do not modify these blocks</li>
         </ul>
        
         <div>
          <img src="../assets/markmind/types.gif" width="800" alt="">
         </div>

      <h3>Screenshot</h3>

  <table>   
     <tr>
        <th>Features</th>
        <th>Short Cut</th>
     </tr>

     <tr>
        <td>Highlight yellow</td>
        <td>CTRL/CMD/ALT + Y</td>
     </tr>

     <tr>
        <td>Highlight green</td>
        <td>CTRL/CMD/ALT + G</td>
     </tr>

     <tr>
        <td>Highlight red</td>
        <td>CTRL/CMD/ALT + R</td>
     </tr>
     <tr>
        <td>Highlight pink</td>
        <td>CTRL/CMD/ALT + P</td>
     </tr>

      <tr>
        <td>Highlight Blue</td>
        <td>CTRL/CMD/ALT + B</td>
     </tr>

  </table>
      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'tableePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
